import { IActionPayload } from 'spw-redux/types';
import {
  DownloadTemplate,
  DownloadTemplateVM,
} from 'spw-programming-projects/downloads/types';
import {
  REPORT_DOWNLOAD_SUCCEEDED,
  REPORT_DOWNLOAD_FAILED,
  CREATE_DOWNLOAD_TEMPLATE,
  CREATE_DOWNLOAD_TEMPLATE_FAILED,
  CREATE_DOWNLOAD_TEMPLATE_SUCCEEDED,
  GET_DOWNLOAD_TEMPLATES,
  GET_DOWNLOAD_TEMPLATES_SUCCEEDED,
  GET_DOWNLOAD_TEMPLATE_DETAIL,
  GET_DOWNLOAD_TEMPLATE_DETAIL_SUCCEEDED,
  UPDATE_DOWNLOAD_TEMPLATE,
  UPDATE_DOWNLOAD_TEMPLATE_FAILED,
  UPDATE_DOWNLOAD_TEMPLATE_SUCCEEDED,
  PREPARE_AND_EXECUTE_REPORT_DOWNLOAD,
  GET_FINISHED_PROJECT_DOWNLOADS_SUCCEEDED,
  CREATE_DOWNLOAD_SUCCEEDED,
  GET_DOWNLOADS_IN_PROGRESS_SUCCEEDED,
  CREATE_DOWNLOAD_FAILED,
  CREATE_DOWNLOAD,
  CHECK_FOR_DOWNLOADS_IN_PROGRESS_SUCCEEDED,
  SET_FAILED_DOWNLOADS_TEMPLATES,
  SET_NUMBER_OF_DOWNLOADS_IN_PROGRESS,
  SET_TEMPLATES_WITH_DOWNLOADS_IN_PROGRESS,
  PREPARE_AND_EXECUTE_BENCHMARK_REPORT_DOWNLOAD,
  PREPARE_AND_EXECUTE_ESA_REPORT_DOWNLOAD,
  PREPARE_AND_EXECUTE_PROGRAMMING_REPORT_DOWNLOAD,
} from './actions';
import { IDownloadState } from './types';

const initialState: IDownloadState = {
  finishedProjectDownloads: [],
  downloadsInProgress: [],
  zipName: '',
  downloadTemplates: [],
  failedDownloadsTemplates: [],
  isLoadingDownloadTemplates: false,
  isLoadingCurrentTemplate: false,
  isDownloadingIndividualReport: false,
  isLoadingCurrentDownload: false,
  areThereAnyDownloadsInProgress: false,
  numberOfDownloadInProgress: 0,
  templatesWithDownloadsInProgressMap: {},
};
const reducer = (
  state: IDownloadState = initialState,
  action: IActionPayload
): IDownloadState => {
  switch (action.type) {
    case PREPARE_AND_EXECUTE_BENCHMARK_REPORT_DOWNLOAD:
    case PREPARE_AND_EXECUTE_ESA_REPORT_DOWNLOAD:
    case PREPARE_AND_EXECUTE_PROGRAMMING_REPORT_DOWNLOAD:
    case PREPARE_AND_EXECUTE_REPORT_DOWNLOAD:
      return {
        ...state,
        isDownloadingIndividualReport: true,

        zipName: action.payload.zipName || action.payload.outputFileName,
      };
    case REPORT_DOWNLOAD_SUCCEEDED:
    case REPORT_DOWNLOAD_FAILED:
      return {
        ...state,
        isDownloadingIndividualReport: false,
        zipName: '',
      };
    case GET_DOWNLOAD_TEMPLATES:
      return {
        ...state,
        isLoadingDownloadTemplates: true,
      };
    case GET_DOWNLOAD_TEMPLATES_SUCCEEDED:
      return {
        ...state,
        downloadTemplates: action.payload as DownloadTemplate[],
        isLoadingDownloadTemplates: false,
      };
    case GET_DOWNLOAD_TEMPLATE_DETAIL:
      return {
        ...state,
        currentDownloadTemplate: null,
        isLoadingCurrentTemplate: true,
      };
    case GET_DOWNLOAD_TEMPLATE_DETAIL_SUCCEEDED:
      return {
        ...state,
        currentDownloadTemplate: action.payload as DownloadTemplateVM,
        isLoadingCurrentTemplate: false,
      };
    case GET_FINISHED_PROJECT_DOWNLOADS_SUCCEEDED:
      return {
        ...state,
        finishedProjectDownloads: action.payload.finishedProjectDownloads,
      };
    case CREATE_DOWNLOAD_TEMPLATE:
    case UPDATE_DOWNLOAD_TEMPLATE:
      return {
        ...state,
        isLoadingCurrentTemplate: true,
      };
    case CREATE_DOWNLOAD_TEMPLATE_SUCCEEDED:
    case UPDATE_DOWNLOAD_TEMPLATE_SUCCEEDED:
    case CREATE_DOWNLOAD_TEMPLATE_FAILED:
    case UPDATE_DOWNLOAD_TEMPLATE_FAILED:
      return {
        ...state,
        isLoadingCurrentTemplate: false,
      };
    case CREATE_DOWNLOAD:
      return {
        ...state,
        isLoadingCurrentDownload: true,
      };
    case CREATE_DOWNLOAD_SUCCEEDED:
    case CREATE_DOWNLOAD_FAILED:
      return {
        ...state,
        isLoadingCurrentDownload: false,
      };
    case CHECK_FOR_DOWNLOADS_IN_PROGRESS_SUCCEEDED:
      return {
        ...state,
        areThereAnyDownloadsInProgress:
          action.payload.areThereAnyDownloadsInProgress,
      };
    case SET_NUMBER_OF_DOWNLOADS_IN_PROGRESS:
      return {
        ...state,
        numberOfDownloadInProgress: action.payload.numberOfDownloadInProgress,
      };
    case GET_DOWNLOADS_IN_PROGRESS_SUCCEEDED:
      return {
        ...state,
        downloadsInProgress: action.payload.downloadsInProgress,
      };
    case SET_TEMPLATES_WITH_DOWNLOADS_IN_PROGRESS:
      return {
        ...state,
        templatesWithDownloadsInProgressMap: action.payload,
      };
    case SET_FAILED_DOWNLOADS_TEMPLATES:
      return {
        ...state,
        failedDownloadsTemplates: action.payload.failedDownloadsTemplates,
      };
    default:
      return state;
  }
};

export default reducer;
